import React, { ReactNode } from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

type MenuCategoryProps = Omit<StylableComponent<HTMLDivElement>, 'title'> & {
  title?: ReactNode;
  titleUnderline?: boolean;
};

/** A MenuCategory component to allow multiple lists in one menu */
const MenuCategory = React.forwardRef<HTMLDivElement, MenuCategoryProps>(
  ({ children, title, titleUnderline, style = {}, className }, ref) => {
    const dynamicTheme = useTheme();
    const category = dynamicTheme.tokens?.component?.menu?.category;

    return (
      <div ref={ref} className={className} css={[style, category?._]}>
        {title && (
          <h4
            dir="auto"
            css={[
              category?.title?._,
              titleUnderline && category?.title?.underline,
            ]}
          >
            {title}
          </h4>
        )}
        {children}
      </div>
    );
  },
);

MenuCategory.displayName = 'MenuCategory';

MenuCategory.propTypes = {
  /** The content to category */
  children: PropTypes.any,
  /* Styles applied to the root element */
  style: stylePropType,
  /* Class applied to the root element */
  className: PropTypes.string,
  /** Category title */
  title: PropTypes.any,
  /** show underline below title */
  titleUnderline: PropTypes.bool,
};

export default MenuCategory;
